import React, { useMemo } from 'react'

import { GridColumnProps } from './GridColumn.types'
import { IThemeContext, ThemeContext } from '../Themer/Themer'
import { useGridContainerContext } from '../GridContainer/GridContainer'

interface GridColumnInteralProps extends GridColumnProps {
    themeContext: any
}

const GridColumnInternal: React.FC<GridColumnInteralProps> = ({
    xs = null,
    sm = null,
    md = null,
    lg = null,
    xl = null,
    children,
    themeContext,
}) => {
    const screenSizeContext = themeContext?.theme?.screenSizeConfig?.screenSizeContext ?? 'lg'
    const base = 100 / 12
    const { spacing } = useGridContainerContext()

    const column = useMemo(() => {
        if (screenSizeContext === 'xs') {
            return xs
        } else if (screenSizeContext === 'sm') {
            return sm
        } else if (screenSizeContext === 'md') {
            return md
        } else if (screenSizeContext === 'lg') {
            return lg
        }
        return xl
    }, [screenSizeContext])

    const width = useMemo(() => {
        const orderStr = ['xs', 'sm', 'md', 'lg', 'xl']
        const order = [xs, sm, md, lg, xl]
        const currentSizeIdx = orderStr.indexOf(screenSizeContext)

        if (column) {
            return base * column
        } else {
            let v = null
            let idx = Math.max(0, currentSizeIdx - 1)
            while (!v) {
                const orderVal = order[idx]
                v = idx === 0 && !orderVal ? 12 : orderVal
                idx -= 1
            }
            return base * v
        }
    }, [column, screenSizeContext])

    return (
        <div
            data-testid='GridColumn'
            style={{
                width: `${width}%`,
                padding: `${spacing / 2}px`,
            }}
            className='r-gridcolumn-container'
        >
            {children}
        </div>
    )
}

const GridColumn: React.FC<GridColumnProps> = (props) => {
    return (
        <ThemeContext.Consumer>
            {(themeContext) => <GridColumnInternal themeContext={themeContext} {...props} />}
        </ThemeContext.Consumer>
    )
}

export default GridColumn
